export default {
      id: "i-logo-black-usage",
      viewBox: "0 0 2439.000000 682.000000",
      url: __webpack_public_path__ + "img/sprite.svg#i-logo-black",
      toString: function () {
        return this.url;
      }
    }